var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.history)?_c('div',[_vm._m(0),_vm._v(" "),_c('products',{attrs:{"category_id":"continue","container":"container","product_id":""}})],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"section-heading-md pb-3"},[_vm._v("Recently viewed products")])])
}]

export { render, staticRenderFns }